import { render, staticRenderFns } from "./GerenciarUnidadeSetor.vue?vue&type=template&id=437e7f89&scoped=true"
import script from "./GerenciarUnidadeSetor.vue?vue&type=script&lang=js"
export * from "./GerenciarUnidadeSetor.vue?vue&type=script&lang=js"
import style0 from "./GerenciarUnidadeSetor.vue?vue&type=style&index=0&id=437e7f89&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437e7f89",
  null
  
)

export default component.exports